const state = {
  basicServices: [],
  basicService: {},
};

export default state;